import Blue from "~/core";

new Blue({
    name:"Career Planning Tool",
    selector: ".aviation-career-planner",
    setup() {
        const careerPlanningToolButton = document.querySelector(".header__plan-button");
        const modalContainer = document.querySelector(".aviation-career-planner");
        const modalCloseButton = document.querySelector(".aviation-career-planner-modal__close");
        const pageOne = document.querySelector(".aviation-career-planner-modal__page-one");
        const careerTypeCards = document.querySelectorAll(".aviation-career-planner__portal-nav-link");
        const pageTwo = document.querySelector(".aviation-career-planner-modal__page-two");
        const backArrowSelector = ".aviation-career-planner-modal__back";
        const careerCardSelector = ".aviation-feature-card";
        const pageThree = document.querySelector(".aviation-career-planner-modal__page-three");
        
        if(careerPlanningToolButton) {
            connectDialogEventListeners();

            connectPageOneEventListeners();
        }
        
        function displayCareerPlanningToolModal() {     
            modalContainer.showModal();
            modalContainer.classList.add("aviation-career-planner--modal-open");
        }

        function closeCareerPlanningToolModal() {
            closeModal();
            resetCareerPlanningToolModal();             
        }

        function resetCareerPlanningToolModal() {
            showPageOne();
        }

        function returnToPreviousPage() {
            if(pageTwo.hidden == false) {
                showPageOne();
            }
            else if(pageThree.hidden == false) {
                showPageTwo();
            }
        }

        function showPageOne() {
            hidePage(pageTwo);
            hidePage(pageThree);
            showPage(pageOne);
        }

        function showPageTwo() {
            hidePage(pageOne);
            hidePage(pageThree);            
            showPage(pageTwo);
        }

        function showPageThree() {
            hidePage(pageOne);
            hidePage(pageTwo);
            showPage(pageThree);
        }

        function showPage(page) {
            page.hidden = false;
            let pageContents = page.querySelector(".aviation-career-planner__slide");

            if(pageContents)
            {
                pageContents.classList.add("slide-visible");
            }
        }

        function hidePage(page) {
            page.hidden = true;
            let pageContents = page.querySelector(".aviation-career-planner__slide")

            if(pageContents) 
            {
                pageContents.classList.remove("slide-visible");
            }
        }

        function closeModal() {
            modalContainer.close();
            modalContainer.classList.remove("aviation-career-planner--modal-open");
        }

        function connectDialogEventListeners() {
                careerPlanningToolButton.addEventListener('click', (e)=> {
                    displayCareerPlanningToolModal();
                });
        
                modalCloseButton.addEventListener('click', (e)=> {
                    closeCareerPlanningToolModal();
                });

                modalContainer.addEventListener('click', (event) => {
                    if(event.target === event.currentTarget){
                        closeModal();
                    }
                })
            }

        function connectPageOneEventListeners() {    
                careerTypeCards.forEach(careerTypeCard => {
                    careerTypeCard.addEventListener('click', (e)=> {
                        e.preventDefault();
                        var url = careerTypeCard.dataset.url;
                        var selectedCareerType = careerTypeCard.dataset.selectedcareertype;
                        proceedToPageTwo(url, selectedCareerType);
                    });
                });
            }

        function connectPageTwoEventListeners() {

            const pageTwoBackArrowSelector = ".aviation-career-planner-modal__page-two " + backArrowSelector;

            document.querySelectorAll(careerCardSelector).forEach(careerCard => {
                careerCard.addEventListener('click', (e)=> {
                    e.preventDefault();
                    var url = careerCard.dataset.url;
                    var selectedCareer = careerCard.dataset.selectedcareer;
                    proceedToPageThree(url, selectedCareer);
                });
            });

            document.querySelector(pageTwoBackArrowSelector)
            .addEventListener('click', ()=> {
                returnToPreviousPage();
            });

        }

        function connectPageThreeEventListeners() {

            const pageThreeBackArrowSelector = ".aviation-career-planner-modal__page-three " + backArrowSelector;

            document.querySelector(pageThreeBackArrowSelector)
            .addEventListener('click', ()=> {
                returnToPreviousPage();
            });
        }

        function proceedToPageTwo(url, selectedCareerType) {


            fetch(`${url}?nodeAliasPath=${encodeURIComponent(selectedCareerType)}`, {
                method: "GET"
            })
            .then(response => response.text())
            .then(data => {
                pageTwo.innerHTML = "";
                pageTwo.innerHTML = data;
        
                connectPageTwoEventListeners();
        
                showPageTwo();
            })
            .catch(error => {
                console.log("Error occured while proceeding to Page Two", error);
            });            
        }

        function proceedToPageThree(url, selectedCareer) {
            fetch(`${url}?nodeAliasPath=${encodeURIComponent(selectedCareer)}`, {
                method: "GET"
            })
            .then(response => response.text())
            .then(data => {
                pageThree.innerHTML = "";
                pageThree.innerHTML = data;
        
                connectPageThreeEventListeners();
        
                showPageThree();
            })
            .catch(error => {
                console.log("Error occured while proceeding to Page Three", error);
            });
        }
    },
});